import { isNil, isNaN } from 'lodash';
import { language } from '@comall-backend-builder/core/lib/services';

var ObjectFormat = function () {
  function ObjectFormat() {}
  /**
   * 对数据进行校验
   */


  ObjectFormat.prototype.validate = function (_rule, value, callback) {
    try {
      if (typeof value !== 'object') {
        JSON.parse(value);
      }

      callback();
    } catch (error) {
      callback(language.getText('validation.object.default'));
    }
  };
  /**
   * 对数据进行格式化
   */


  ObjectFormat.prototype.format = function (value) {
    if (isNil(value) || isNaN(value)) {
      return value.toString();
    } else {
      return '';
    }
  };
  /**
   * 将数据格式化为请求参数
   */


  ObjectFormat.prototype.formatParams = function (key, value) {
    var _a, _b;

    try {
      return _a = {}, _a[key] = typeof value === 'object' ? value : JSON.parse(value), _a;
    } catch (e) {
      return _b = {}, _b[key] = null, _b;
    }
  };

  return ObjectFormat;
}();

export { ObjectFormat };